/**
 * 草稿编辑数据服务（Axios 版本）
 * 替换原有的 WebSocket 实现
 */
import { ref } from 'vue';
import { getOneNovel, getDraftContent, updateDraft, publishDraft } from './api';

export const draftAndPutDraftWebSocket = (currentId, novel_id) => {
    const connected = ref(true); // Axios 总是"连接"状态
    const chapterId = ref(currentId);
    const novelId = ref(novel_id);
    const novels = ref({});
    const draft_content = ref({});
    const loading = ref(false);
    const errorItNovel = ref(null);
    const error = ref(null);

    // 请求小说详情和草稿内容
    const fetchNovelsChapter = async () => {
        loading.value = true;
        errorItNovel.value = null;
        error.value = null;

        try {
            // 并行请求小说详情和草稿内容
            const [novelResult, contentResult] = await Promise.all([
                getOneNovel(novelId.value),
                getDraftContent(novelId.value, chapterId.value)
            ]);

            // Result 结构：{ code: 0, msg: "success", data: [...] }
            if (novelResult.code === 0) {
                novels.value = novelResult.data;
                console.log('获取小说信息成功');
            } else {
                errorItNovel.value = novelResult.msg || '获取小说信息失败';
            }

            if (contentResult.code === 0) {
                draft_content.value = contentResult.data;
                console.log('获取草稿内容成功');
            } else {
                error.value = contentResult.msg || '获取草稿内容失败';
            }
        } catch (err) {
            console.error('请求数据失败:', err);
            errorItNovel.value = err.message || '请求数据失败';
            error.value = err.message || '请求数据失败';
        } finally {
            loading.value = false;
        }
    };

    // 更新草稿
    const updateDraftChapter = async (updateChapterData, updateContentData) => {
        loading.value = true;
        errorItNovel.value = null;
        error.value = null;

        try {
            const result = await updateDraft(updateChapterData, updateContentData);
            if (result.code === 0) {
                console.log('更新草稿成功');
            } else {
                errorItNovel.value = result.msg || '更新草稿失败';
            }
        } catch (err) {
            console.error('更新草稿失败:', err);
            errorItNovel.value = err.message || '更新草稿失败';
        } finally {
            loading.value = false;
        }
    };

    // 草稿转正（发布为章节）
    const putDraftChapter = async (updateChapterData, updateContentData) => {
        loading.value = true;
        errorItNovel.value = null;
        error.value = null;

        try {
            const result = await publishDraft(updateChapterData, updateContentData);
            if (result.code === 0) {
                console.log('发布草稿成功');
            } else {
                errorItNovel.value = result.msg || '发布草稿失败';
            }
            return result;
        } catch (err) {
            console.error('发布草稿失败:', err);
            errorItNovel.value = err.message || '发布草稿失败';
            throw err;
        } finally {
            loading.value = false;
        }
    };

    return {
        connected,
        novels,
        draft_content,
        loading,
        errorItNovel,
        error,
        fetchNovelsChapter,
        updateDraftChapter,
        putDraftChapter,
    };
};
